<template>
  <div class="mx-4">
    <Loader v-if="loading"/>
    <div class="matching" v-else>
      <div class="row justify-content-center">
          <div class="col-md-6">
              <JobDescription :job="currentJd" />
          </div>
          <Loader v-if="isSubmitting"/>
          <div class="col-md-6">
              <div class="profile-header">
                <p>プロフィール</p>
              </div>
              <div class="error-class text-center">
                <p v-html="errorMessage"></p>
              </div>
              <div class="profile-block">
                <Profile :applicant-id="currentJobSeeker.id" :paddingClass="true" v-if="jobSeekers.length > 0 && !endOfList" :hideMailIcon="true" :hideDownloadPdf="true" :isMaxHeight="true" />
              </div>
          </div>
      </div>
      <div class="button-container" v-if="jobSeekers.length>0 && !endOfList">
          <button class="btn btn-primary select-btn me-3" :class="colorClass" @click="handleCandidateSelection(true)" :disabled="isSubmitting">{{user.companyJdStatus}}</button>
          <button class="btn btn-primary reject-btn " @click="handleCandidateSelection(false)" :disabled="isSubmitting">次へ進む</button>
      </div>
    </div>
  </div>
</template>

<script>
import JobDescription from './JobDescription.vue'; // Import the JobDescription component
import Profile from '../applicants/profile/Profile.vue'; // Import the Profile component
import apiService from '../../../service/apiService';
import api from '../../../config/api';
import Loader from '../../utils/Loader.vue';
import moment from 'moment';
import { mapGetters } from 'vuex';
export default {
  components: {
    JobDescription,
    Profile,
    Loader
  },
  data() {
    return {
      jobSeekers: [
        
      ], // Populate this array with data from your API response
      currentIndex: 0,
      currentJd: {},
      errorMessage: '',
      endOfList: false,
      loading: false,
      isSubmitting: false,
    };
  },
  computed: {
    ...mapGetters({
      user: 'getCurrentUser',
      isReviewer: 'isCreateReviewUser',
      statusColorMap: 'getStatusColorMap'
    }),
    currentJobSeeker() {
      // console.log(this.jobSeekers[this.currentIndex]);
      return this.jobSeekers[this.currentIndex] || {};
    },
    colorClass() {
        const status = this.user.companyJdStatus;
        const colorMap = this.statusColorMap;
        for(let color in colorMap){
            if(colorMap[color].includes(status)){
                return color;
            }
        }
        return '';
    },
  },
  methods: {
    async handleCandidateSelection(eligibility) {
      this.isSubmitting=true;
      try {
        const { id, matching_Score } = this.currentJobSeeker;
        let data = {
          // eligibility: eligibility,
          jobseekerId: id,
          // matching_score: matching_Score
        }
        if(eligibility) {
          data.timestamp = moment().format('YYYY-MM-DD HH:mm');
          let selectCandidate = await apiService.put(api.endpoints.MARK_JOBSEEKERS(this.currentJd._id), data);
        } else {
          await apiService.put(api.endpoints.MARK_INELIGIBLE(this.currentJd._id, id), data);
        }
       
        this.isSubmitting = false;
        this.currentIndex++;
      } catch(err) {
        this.isSubmitting = false;
        console.log(err);
      }
    },
    async getJD(id){
      this.loading = true;
      try {
        const jd = await apiService.get(api.endpoints.JD_BY_ID(id));
        this.currentJd = jd.data.data;
        this.loading = false;
      } catch(err) {
        this.parseErrorResponse(err.response);
        this.loading = false;
      }
    },
    async getMatchingJobseekerList(id, filters = {}) {
      try {
        const queryParams = {
          created_date: filters.created_date || '',
          age_from: filters.age_from || '',
          age_to: filters.age_to || '',
          last_year_income_from: filters.last_year_income_from || '',
          last_year_income_to: filters.last_year_income_to || '',
          status: filters.status || '',
          english_skills: filters.english_skills || [],
          latest_occupation_sub_title: filters.latest_occupation_sub_title || [],
          latest_occupation_main_title: filters.latest_occupation_main_title || [],
        };
        const matchingList = await apiService.get(api.endpoints.MATCHING_BY_JD(id), {}, queryParams);
        // console.log(matchingList.data.data.matchedJobseekers);
        this.jobSeekers = matchingList.data.data.matchedJobseekers;
      } catch(err) {
        console.log(err)
        // console.log(err.response);
        if(err && err.response && err.response.status === 404) {
          this.errorMessage = '候補者が見つかりませんでした<br/>別の募集Job Descriptionのマッチングへお進みください';
        } else {
          this.errorMessage = '何らかのエラーが発生しています<br/>時間を置いても改善されない場合は、Bloom技術チームにお知らせください';
        }
      }
    }
  },
  async created() {
    const id = this.$route.params.id
    await this.getJD(id);
    
    const { status, english_skills, latest_occupation_sub_title, latest_occupation_main_title, created_date, age_from, age_to, last_year_income_from, last_year_income_to } = this.$route.query;

    // Convert comma-separated strings back to arrays
    const filters = {
      created_date,
      age_from,
      age_to,
      last_year_income_from,
      last_year_income_to,
      status: status ? status.split(',') : [],
      english_skills: english_skills ? english_skills.split(',') : [],
      latest_occupation_sub_title: latest_occupation_sub_title ? latest_occupation_sub_title.split(',') : [],
      latest_occupation_main_title: latest_occupation_main_title ? latest_occupation_main_title.split(',') : [],
    };

    await this.getMatchingJobseekerList(id, filters);
  },
  mounted(){
    this.changeBodyBackground();
  },
  watch:{
    currentIndex(newIndex) {
      if(newIndex >= this.jobSeekers.length) {
        this.endOfList = true;
        this.errorMessage = 'これ以上適任な候補者が見つかりませんでした<br/>別の募集Job Descriptionのマッチングへお進みください';
      } else {
        this.endOfList = false;
      }
    }
  }
};
</script>


<style scoped>


/* @media (max-width: 1470px) { */
.profile-block{
  height: 70vh !important;
  overflow-y: scroll !important;
  overflow-x: hidden;
  background: white;
}
/* } */

.profile-header {
  padding: 2px;
  margin-top: 10px;
  background-color: #036d6c;
}
.profile-header p {
  font-size: 20px;
  color: white;
  font-weight: bold;
  margin: auto;
  padding: 10px;
}
.button-container {
  text-align: center;
  /* margin-top: 10px; */
}
.btn-primary {
  border-radius: 8px !important;
  font-weight: bold;
  font-size: 18px;
  width: 230px;
}

.select-btn,
.select-btn:focus, 
.select-btn:disabled{
  /* background-color: #7ba27b !important; */
  border-color: #cae9be;
  color: #fff;
  box-shadow: none !important;
}

.select-btn:hover {
  opacity: 0.8;
}

.reject-btn,
.reject-btn:hover,
.reject-btn:focus,
.reject-btn:disabled {
    background-color: #6c757d !important;
    border-color: #ffffff;
    color: #fff;
    box-shadow: none !important;
}

.error-class {
  position: absolute;
  top: 50%;
  left: 10%;
  right: 10%;
}

.error-class p {
  font-size: 20px;
  font-weight: bold;
}


.pink  {
  color: #fff;
  background-color: #b97070;
  border-color: #b97070;
}
.grey {
  color: #fff;
  background-color: #ab8371 !important;
  border-color: #ab8371;
}
.green  {
  color: #fff;
  background-color: #5bb55b;
  border-color: #5bb55b;
}
.lightblue  {
  color: #fff;
  background-color: #7070af;
  border-color: #7070af;
}
.lightgreen  {
  color: #fff;
  background-color: #7ba27b;
  border-color: #7ba27b;
}
.red  {
  color: #fff;
  background-color: #ab8371;
  border-color: #ab8371;
}
.yellow {
  color: #000;
  background-color: #ffea00;
  border-color: #ffea00;
}

.pink:hover,
.show.pink button {
  background-color: white !important;
  color: black !important;
  border-color: #b97070 !important;
}
.grey:hover,
.show.grey button {
  background-color: white !important;
  color: black !important;
  border-color: #ab8371 !important;
}
.green:hover,
.show.green button {
  background-color: white !important;
  color: black !important;
  border-color: #5bb55b !important;
}
.lightblue:hover,
.show.lightblue button {
  background-color: white !important;
  color: black !important;
  border-color: #7070af !important;
}
.lightgreen:hover,
.show.lightgreen button {
  background-color: white !important;
  color: black !important;
  border-color: #7ba27b !important;
}

.yellow:hover,
.show.yellow button {
  background-color: white !important;
  color: black !important;
  border-color: #ffea00 !important;
}

</style>
